import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { QueryParameters, VqlQuery } from "types";
import { VQL_PARAMETER } from "helpers/constants/miscellaneous";
import { extractValuesFromVqlQueries } from "helpers/utility/vqlHelpers";

const useQueryParam = (paramName: QueryParameters): string | null => {
  const location = useLocation();
  const paramValue = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);

    // First check VQL parameter
    if (paramName !== VQL_PARAMETER) {
      const vqlParam = searchParams.get(VQL_PARAMETER);
      if (vqlParam) {
        try {
          const vqlQueries = JSON.parse(vqlParam) as VqlQuery[];
          const extractedValues = extractValuesFromVqlQueries(vqlQueries);

          if (paramName in extractedValues) {
            return extractedValues[paramName];
          }
        } catch (error) {
          console.error("Error parsing VQL parameter:", error);
        }
      }
    }

    // If no VQL value found, fall back to regular URL parameters
    const regularParamValue = searchParams.get(paramName);
    if (regularParamValue) {
      return decodeURIComponent(regularParamValue);
    }

    return null;
  }, [location.search, paramName]);

  return paramValue;
};

export default useQueryParam;
